var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadComponent)?_c('div',[_c('v-container',[_c('h1',{staticClass:"pb-1 mb-1"},[_vm._v("Bank Information")]),_c('pagination')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }